import React from 'react';
import CalculatorDisplay from './CalculatorDisplay';
import CalculatorKey from './CalculatorKey';
import AutoScalingText from './AutoScallingText';

// Arithmetic operations
const CalculatorOperations = {
  '/': (prevValue, nextValue) => prevValue / nextValue,
  '*': (prevValue, nextValue) => prevValue * nextValue,
  '+': (prevValue, nextValue) => prevValue + nextValue,
  '-': (prevValue, nextValue) => prevValue - nextValue,
  '=': (prevValue, nextValue) => nextValue
}

// Calculator Component
export default class Calculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      displayValue: '0',
      operator: null,
      waitingForOperand: false
    }
  }

  clearAll() {
    this.setState({
      value: null,
      displayValue: '0',
      operator: null,
      waitingForOperand: false
    })
  }

  clearDisplay() {
    this.setState({
      displayValue: '0'
    })
  }

  clearLastChar() {
    const { displayValue } = this.state

    this.setState({
      displayValue: displayValue.substring(0, displayValue.length - 1) || '0'
    })
  }

  toggleSign() {
    const { displayValue } = this.state
    const newValue = parseFloat(displayValue) * -1

    this.setState({
      displayValue: String(newValue)
    })
  }

  inputPercent() {
    const { displayValue } = this.state
    const currentValue = parseFloat(displayValue)

    if (currentValue === 0)
      return

    const fixedDigits = displayValue.replace(/^-?\d*\.?/, '')
    const newValue = parseFloat(displayValue) / 100

    this.setState({
      displayValue: String(newValue.toFixed(fixedDigits.length + 2))
    })
  }

  inputDot() {
    const { displayValue } = this.state

    if (!(/\./).test(displayValue)) {
      this.setState({
        displayValue: displayValue + '.',
        waitingForOperand: false
      })
    }
  }

  inputDigit(digit) {
    const { displayValue, waitingForOperand } = this.state

    if (waitingForOperand) {
      this.setState({
        displayValue: String(digit),
        waitingForOperand: false
      })
    } else {
      this.setState({
        displayValue: displayValue === '0' ? String(digit) : displayValue + digit
      })
    }
  }

  performOperation(nextOperator) {
    const { value, displayValue, operator } = this.state
    const inputValue = parseFloat(displayValue)

    if (value == null) {
      this.setState({
        value: inputValue
      })
    } else if (operator) {
      const currentValue = value || 0
      const newValue = CalculatorOperations[operator](currentValue, inputValue)

      this.setState({
        value: newValue,
        displayValue: String(newValue)
      })
    }

    this.setState({
      waitingForOperand: true,
      operator: nextOperator
    })
  }

  render() {
    const { displayValue } = this.state

    const clearDisplay = displayValue !== '0'
    const clearText = clearDisplay ? 'C' : 'AC'

    return (
      <div id="calc-wrapper" className="flexing">
        <div id="calc-app">
          <div id="calculator" className="align-center">
            <CalculatorDisplay value={displayValue}/>
            <div className="calculator-keypad">
              <div className="input-keys">
                <div className="function-keys">
                  <CalculatorKey className="key-clear" onPress={() => clearDisplay ? this.clearDisplay() : this.clearAll()}>{clearText}</CalculatorKey>
                  <CalculatorKey className="key-sign" onPress={() => this.toggleSign()}>±</CalculatorKey>
                  <CalculatorKey className="key-percent" onPress={() => this.inputPercent()}>%</CalculatorKey>
                </div>
                <div className="digit-keys">
                  <CalculatorKey className="key-0" onPress={() => this.inputDigit(0)}>0</CalculatorKey>
                  <CalculatorKey className="key-dot" onPress={() => this.inputDot()}>●</CalculatorKey>
                  <CalculatorKey className="key-1" onPress={() => this.inputDigit(1)}>1</CalculatorKey>
                  <CalculatorKey className="key-2" onPress={() => this.inputDigit(2)}>2</CalculatorKey>
                  <CalculatorKey className="key-3" onPress={() => this.inputDigit(3)}>3</CalculatorKey>
                  <CalculatorKey className="key-4" onPress={() => this.inputDigit(4)}>4</CalculatorKey>
                  <CalculatorKey className="key-5" onPress={() => this.inputDigit(5)}>5</CalculatorKey>
                  <CalculatorKey className="key-6" onPress={() => this.inputDigit(6)}>6</CalculatorKey>
                  <CalculatorKey className="key-7" onPress={() => this.inputDigit(7)}>7</CalculatorKey>
                  <CalculatorKey className="key-8" onPress={() => this.inputDigit(8)}>8</CalculatorKey>
                  <CalculatorKey className="key-9" onPress={() => this.inputDigit(9)}>9</CalculatorKey>
                </div>
              </div>
              <div className="operator-keys">
                <CalculatorKey  className="key-divide" onPress={() => this.performOperation('/')}>÷</CalculatorKey>
                <CalculatorKey className="key-multiply" onPress={() => this.performOperation('*')}>×</CalculatorKey>
                <CalculatorKey className="key-subtract" onPress={() => this.performOperation('-')}>−</CalculatorKey>
                <CalculatorKey className="key-add" onPress={() => this.performOperation('+')}>+</CalculatorKey>
                <CalculatorKey className="key-equals" onPress={() => this.performOperation('=')}>=</CalculatorKey>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
